/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Maintenance_Labels_InterventionInputs */



/**
* | output |
* | --- |
* | "Equipment under intervention" |
*
* @param {Maintenance_Labels_InterventionInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const maintenance_labels_intervention = /** @type {((inputs?: Maintenance_Labels_InterventionInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Maintenance_Labels_InterventionInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Equipment under intervention")
	return /** @type {LocalizedString} */ ("Équipements en intervention")
});